<template>
  <div>
      <img src="../assets/shj.png" alt="">
      <div class="ws_SX"><img src="../assets/ws_SX.png" alt=""></div>
      <img src="../assets/conWarp.png" alt="">
      <img src="../assets/shj_feature.png" alt="">
      <div class="clearfix">
        <img src="../assets/clearfix.png" alt="">
      </div>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped lang='less'>
img{
  vertical-align:top
}
.ws_SX{
    width: 100%;
    height: 700px;
    img{
        width: 100%;
        height: 100%;
    }
}
.clearfix{
    // background: pink;
    width: 1188px;
     margin: 0 auto;
    img{
       
    }
}
</style>